import {Paths} from "common";
import {SortOrder} from "../domain";

export interface ProgressPortraitColumn {
    name: string;
    attr: Paths<ProgressPortrait>;
}

export interface ProgressPortraitSortBy {
    column: Paths<ProgressPortrait>;
    order: SortOrder;
}

export type ProgressPortrait = {
    guid: string;
    sfCaseId: string;
    caseNumber: string;
    reportDate: string;
    providerGuid: string;
    parentCaseGuid: string;
    clientProfileGuid: string;
    hasProviderProgressPortrait: boolean;
    providerProgressPortraitFileName: string | null;
}

export type ProgressPortraitListFilterValue = {
    clientGuid: string;
    reportDateFrom: Date | null;
    reportDateTo: Date | null;
}

export enum ProgressPortraitFileType {
    FAMILY_CLIENT = 'FAMILY_CLIENT',
    PROVIDER = 'PROVIDER',
    FUNDER = 'FUNDER',
}

export const ProgressPortraitClientProfileListColumn: Readonly<ProgressPortraitColumn[]> = [
    {name: 'Date Created', attr: 'reportDate'},
    {name: 'Operations Case Number', attr: 'caseNumber'},
    {name: 'Provider Progress Portrait', attr: 'hasProviderProgressPortrait'},
] as const;
